import { FULL_HD, HD, safetyMargins } from '@bedrock-rdk/constants';
import { makeDefaultStylingContext } from '../../../utils/style';
import { getTitleStyle } from '../../../block/block.style';
import { HEIGHT as TIMELINE_HEIGHT } from './epgTimeline/epgTimeline.style';
import { PIXELS_PER_MINUTE } from './epg.constants';

export const defaultContext = makeDefaultStylingContext();

export const MAX_VISIBLE_ROWS = {
  [HD]: 4,
  [FULL_HD]: 5,
};

export const SCROLL_START_ROW = 3;

export const GAP = 16;

export const RIGHT_PADDING = safetyMargins.horizontal;

export const CHANNEL_SIZE = {
  [HD]: 96,
  [FULL_HD]: 112,
};

export const TIMELINE_MARGIN_TOP = 32;

export const TIMELINE_MARGIN_BOTTOM = 24;

export const ARROW_SLIDE_INTERVAL = {
  [HD]: PIXELS_PER_MINUTE * 60,
  [FULL_HD]: PIXELS_PER_MINUTE * 90,
};

export const getInitialStyle = (style = defaultContext) => ({
  ChannelsVerticalClippingRoot: {
    w: CHANNEL_SIZE[style.screenSize],
  },
  Grid: {
    Timeline: {
      y: TIMELINE_MARGIN_TOP,
    },
    GridRoot: {
      y: TIMELINE_HEIGHT[style.screenSize] + TIMELINE_MARGIN_BOTTOM + TIMELINE_MARGIN_TOP,
    },
  },
  Title: getTitleStyle(style),
});

export const EMPTY_VIEW = {
  Channels: {
    children: [],
  },
  Grid: {
    GridRoot: {
      rows: { rows: [], pages: {}, pagination: {} },
    },
  },
  Title: {
    text: {
      text: '',
    },
  },
};
